import { useQuery } from "@tanstack/react-query";
import { mapSelectOptions } from "../../../utils/map4select";
import { FilterSelectOption } from "../../filters/filters.types";
import { exciseStampKeys } from "./exciseStamps.keys";
import { exciseStampsService } from "./exciseStamps.service";
import {
  ExciseStampRequestListPayload,
  ExciseStampRequestListResponse,
} from "./exciseStamps.types";

/**
 * Hook used to fetch data for excise stamp request list
 * @param filters Filters applied to table data
 * @param enabled If true API call is initiated immediately
 * @returns Filter dropdown values that can be applied to data and data after/before data
 */
export function useExciseStampRequestList({
  filters,
  enabled,
}: {
  filters: ExciseStampRequestListPayload;
  enabled?: boolean;
}) {
  return useQuery({
    ...exciseStampKeys.exciseStampRequestList({ filters }),
    queryFn: () => exciseStampsService.postSviZahteviZaMarkicu(filters),
    select: (response): ExciseStampRequestListResponse => ({
      exciseStampRequestList: response?.data?.markiceZahtevi ?? [],
      productTypes: mapSelectOptions<FilterSelectOption>({
        labelAccessor: "name",
        valueAccessor: "id",
        sourceArray: response?.data?.vrsteFilters,
      }),
      statuses: mapSelectOptions<FilterSelectOption>({
        labelAccessor: "name",
        valueAccessor: "id",
        sourceArray: response?.data?.filters,
      }),
    }),
    retry: false,
    enabled,
  });
}
